import * as css from 'css/exports.module.scss';

import './Record.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { ifClickHandler } from '@lib/events';
import { SonarRecordContainer } from './RecordContainer';
import { SonarRecordNameSection } from './RecordNameSection';
import { SonarRecordReferences } from './RecordReferences';
import { SonarRecordRelationships } from './RecordRelationships';
import { SonarRecordRow } from './RecordRow';
import { SonarRecordSecondaryInfo } from './RecordSecondaryInfo';
import { SonarText } from '../text';
import { When } from 'react-if';

import { Col, Space } from 'antd';
import { OrganizationTypeId, RelatedCounts, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { PropsWithChildren, useMemo } from 'react';

export interface SonarRecordProps {
	className?: string;
	isActive?: boolean;
	isDeleted?: boolean;
	name: string | React.ReactElement | Array<string | React.ReactElement>;
	onClick?: () => void;
	onClickParent?: () => void;
	parentName?: string;
	relatedCounts?: RelatedCounts;
	relatedOrgs?: Array<OrganizationTypeId>;
	relatedField?: string;
	rightEnd?: string | React.ReactNode;
	secondaryInfo?: string | React.ReactNode;
	sonarObjectId: number | null;
	sonarObjectType?: SonarObjectType;
	source?: string;
	versionNumber?: number;
	showType?: boolean;
}

export const SonarRecord: React.FC<PropsWithChildren<SonarRecordProps>> = ({
	children,
	className,
	isActive,
	isDeleted,
	name,
	onClick,
	onClickParent,
	parentName,
	relatedCounts,
	relatedOrgs,
	relatedField,
	rightEnd,
	secondaryInfo,
	sonarObjectId,
	sonarObjectType,
	source,
	versionNumber,
	showType
}) => {
	const handleOnClickParent = useMemo(() => ifClickHandler(onClickParent), [ onClickParent ]);
	const showRelatedCounts = sonarObjectType !== SonarObjectType.SalesforceEntity;

	return (
		<SonarRecordContainer
			className={ className }
			onClick={ onClick }>
			<SonarRecordRow>
				<Col
					className='primary-info'
					flex='none'>
					<Space size={ Number(css.size8) }>
						<SonarRecordNameSection
							isActive={ isActive }
							name={ name }
							onClickParent={ handleOnClickParent }
							parentName={ parentName }
							versionNumber={ versionNumber } />
						<SonarRecordRelationships
							relatedField={ relatedField }
							relatedOrgs={ relatedOrgs }
							source={ source } />
						<SonarRecordReferences
							parentName={ parentName }
							relatedCounts={ showRelatedCounts ? relatedCounts : undefined }
							sonarObjectId={ sonarObjectId ?? 0 } />
						<When condition={ isDeleted }>
							<SonarText type='danger'>{ COPY_SPECIFIC.DELETED }</SonarText>
						</When>
					</Space>
				</Col>
				<SonarRecordSecondaryInfo
					info={ secondaryInfo }
					sonarObjectType={ showType ? sonarObjectType : undefined } />
				{ rightEnd }
			</SonarRecordRow>
			{ children }
		</SonarRecordContainer>
	);
};
